export default __webpack_public_path__ + "static/media/photo10.99dc4f12.jpeg";